document.addEventListener('touchstart', function() {
    return false;
}, true);

// common -- animate.css
function animated(obj, type){
    obj.addClass(type + ' animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass(type + ' animated');
    });
}

window.onload = function(){

    //pc nav 
     $(".q_language").hover(function(){
        $(this).stop().animate({"width":"1.6rem"},500)
   },function(){
        $(this).stop().animate({"width":".54rem"},500)
    });
   //懒加载
   $(".img_lazyload").lazyload();

//图片缩放
   $("img.scale").imageScale();

//导航
    $(".q_navbtn").click(function(){
                if($('.q_hdnav').css("display") == 'none'){
                    $('.q_hdnav').stop().slideDown();
                }else{
                    $('.q_hdnav').stop().slideUp();
                    $('.q_hdnav .q_hide').stop().slideUp();
                }
            })
            $(".q_hdnav li").each(function(index,ele){
                var lisize = $(this).find(".q_hide a").length;
                if(lisize > 0){
                    $(this).on("click",".q_firnavem",function(e){
                        e.preventDefault();
                        if($(this).next().css("display") == 'none'){
                            $(this).next().stop().slideDown();
                            $(this).parents("li").siblings().find(".q_hide").stop().slideUp();
                        }else{
                            $(this).next().stop().slideUp();
                        }
                    });
                }
            });
   
    // 首页视频
    $('.q_ClickVideo').click(function(){
        $('.video_popup').fadeIn();

        if ($("video#myvideo").attr("src") == undefined) {
            $("video#myvideo").attr("src",$("video#myvideo").attr("data-src"));
        };

        var myPlayer = videojs('myvideo',function(){
            this.play();
        });

        $('.video_popup img.close').click(function(){
            myPlayer.pause();
            $('.video_popup').fadeOut();
        });

    });
/*
    var hetdefault = $(".q_conlunbo .q_consitem").eq(0).height();
    $(".q_conlunbo").height(hetdefault);
*/
  //  $(window).resize(function(){
        var winwidth = $(window).width(),
        tsize = $(".q_teletab li").length;
        if(tsize < 5){
        $(".q_tbutton").hide();
        }
      /*  $(".q_consitem").width(winwidth);
        $(".q_conshow").width(winwidth*tsize + "px");
        $(".q_teletab li").click(function(){
            $(this).addClass("active").siblings().removeClass("active");
            var ind = $(this).index();
            var distance = -winwidth * ind;
            var curheight = $(".q_consitem").eq(ind).height();
            $(".q_conlunbo").height(curheight)
            $(".q_conshow").stop().animate({left:distance},500)
        });
       */

 $(".wap_third").css({'background':"url("+$(".wap_third .wptha").eq(0).attr("data-src")+") no-repeat center center / cover"});

$(".wap_third .wptha").mouseenter(function(){
       var srcc = $(this).attr("data-src");
       $(this).parent().css({'background':"url("+srcc+") no-repeat center center / cover"})
       $(".wpcur").show().prev().hide();
       $(this).addClass("on").siblings(".wptha").removeClass("on");
       $(this).find(".hlink").show();
$(this).siblings(".wptha").find(".hlink").hide();
});

        $('img.scale').imageScale();

        // wap nav
        if(winwidth < 750){

            var heit = $(".q_conttop").height();
            var heit2 = $(".q_abomsg").height();
            if(heit < 118){
                $(".q_conttop").next(('.show_more')).hide();
            }else{
                $(".q_conttop").next(('.show_more')).show().click(function(e){
                    $(".q_conttop").css({"max-height":"initial"});
                        $(this).hide();
                    });
            }
 if(heit2 < 120){
                $(".q_abomsg").next(('.show_more')).hide();
            }else{
                $(".q_abomsg").next(('.show_more')).show().click(function(e){
                    $(".q_abomsg").css({"max-height":"initial"});
                        $(this).hide();
                    });
            }
     
/*  
//wap地图下拉
$(".q_wap_map .q_option").click(function(e){
                e.stopPropagation();
                var nxt = $(this).next();
                if(nxt.css("display") == "none"){
                    nxt.slideDown();
                    nxt.find("li").click(function(ele){
                        var text = $(this).find("a").text();
                        $(".q_option").text(text);
                        nxt.slideUp();
                    })
              } 
            });
*/


// fixednav
$(".sec_section").css("background","url("+$(".q_scdscroll .q_secondwrap").eq(2).attr("data-src")+") no-repeat center top /cover");
$(".q_scdscroll .q_secondwrap").eq(2).show().css("opacity",1);
$(".navnavnav a").eq(0).removeClass("on");
$(".navnavnav a").eq(2).addClass("on").prev().addClass("csslink").next().next().addClass("csslink");
 $(".navnavnav").on("click","a",function(){
            var ind = $(this).index();
            var wrap = $(".q_scdscroll .q_secondwrap").eq(ind);
            var src = wrap.attr("data-src");

            $(this).removeClass("csslink").addClass("on").siblings().removeClass("on csslink");
            $(this).prev().addClass("csslink");
            $(this).next().addClass("csslink");
            wrap.show().css("opacity",1);
            wrap.siblings().css("opacity",0).hide();
            $(".sec_section").css("background","url("+src+") no-repeat center top /cover");
            wrap.find(".q_secright img.scale").imageScale();
        });
          /*      TouchSlide({
                    slideCell: "#fixednav",
                    mainCell: ".navnavnav",
                    effect:"leftLoop",
                    startFun:function(i){
                        $(".navnavnav a").removeClass("csslink on");
                        $(".navnavnav a").eq(i+3).addClass("on").prev().addClass("csslink").next().next().addClass("csslink");
$(".sec_section").css("background","url("+$(".q_scdscroll .q_secondwrap").eq(2).attr("data-src")+") no-repeat center top /cover");
              $(".q_scdscroll .q_secondwrap").eq(2).show().css("opacity",1);
    
       


                    }, 
                    endFun:function(i,c){
                        $(".bdbdbdbd .slideimg").eq(i+1).removeClass("q_gray").siblings().addClass("q_gray");
                    }
                });
*/

        }

        $(".q_ivtlist li").each(function(index,e){
            if((index+1) % 4 == 0){
                $(this).addClass("mr0");
            }
        });
        
        $(".q_serverlist li").each(function(index,e){
            if((index+1) % 3 == 0){
                $(this).addClass("mr0");
            }
        });

        $(".q_connect li").each(function(index,e){
            if((index+1) % 2 == 0){
                $(this).addClass("mr0");
            }
        });

        //index
        var itemht = $(".q_fourth").find(".q_forlist").height();
        $(".q_fourth .flleft").height(itemht);

        var height = $(window).height();
            $(".q_thirdul li").height(height); 

 //   }).resize();

    //index
    $(".q_niimg").eq(0).stop().animate({opacity:1}).show();
    $(".q_forlist .q_forthitem:first-child").addClass("active");
    $(".q_forthitem").each(function(index,e){
        var src = $(this).attr("data-src");
        $(this).mouseenter(function(){
            $(this).addClass("active").siblings().removeClass("active");
            $(".q_niimg").eq(index).stop().animate({opacity:1}).show().siblings().stop().animate({opacity:0}).hide();
$('img.scale').imageScale();
        });
    });

    $(".q_fotitem .q_fotcolumnem").click(function(e){
      
        if($(this).next().css("display") == 'none'){
            $(this).next().stop().slideDown();
            $(this).parents(".q_fotitem").siblings().find(".q_fotsecd").stop().slideUp();
        }else{
            $(this).next().stop().slideUp();
        }
    });

    
}    
